export const numberRange = (start, end) => Array.from({ length: end - start + 1 }, (_, i) => start + i);
//# sourceMappingURL=numberRange.js.map